import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import ResetMany, {
  ResetManyRansack,
} from 'api/administration/monitoring/ResetMany'
import { CourseUser } from 'graphqlAPI'
import { ResetModal } from 'components/ui/modals/reset/ResetModal'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'

const ResetSelection: React.FC<{
  courseId: number | string
  className: string
  searchText: string
  count: number
  disabled?: boolean
  q: ResetManyRansack
  ransackQueryGroup?: any
  onDeleted?: () => void
  selectedUsers: CourseUser[]
}> = ({
  courseId,
  className,
  searchText,
  count,
  disabled,
  q,
  onDeleted,
  ransackQueryGroup,
}) => {
  const { t } = useTranslation()
  const prefix = 'administration.monitor.resetSelected'
  const [showModal, setShowModal] = useState(false)

  const handleClose = () => {
    setShowModal(false)
  }

  const handleReset = async () => {
    await ResetMany(courseId, {
      search: searchText,
      q: {
        ...q,
        g: ransackQueryGroup,
      },
    })
    setShowModal(false)
    onDeleted?.()
  }

  return (
    <>
      <Dropdown.Item
        disabled={count < 1 || disabled}
        className={className}
        onClick={() => setShowModal(true)}
      >
        {t(`${prefix}.buttonShort`, {
          count: count,
        })}
      </Dropdown.Item>
      <ResetModal
        title="Reiniciar curso"
        show={showModal}
        securityWord="REINICIAR"
        text={t(`${prefix}.modal.warning`)}
        textConfirmation={t(`${prefix}.modal.confirm`)}
        acceptButtonText={t(`${prefix}.modal.reset`)}
        onClose={() => handleClose()}
        onAccept={() => handleReset()}
      />
    </>
  )
}

export default ResetSelection
